import { memo } from 'react';
import PropTypes from 'prop-types';

import { NavLink } from 'react-router-dom';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';

import LogoHeader from './LogoHeader';
import MDBox from '../../components/MDBox';
import sidenavLogoLabel from './styles/sidenav';
import MDTypography from '../../components/MDTypography';

const CompanyHeader = ({ companyData, miniSidenav, textColor }) => {
  // Check di sicurezza: se i dati non ci sono, mostriamo un fallback o nulla
  if (!companyData || !companyData.company) {
    return (
      <MDBox component={NavLink} to="/" display="flex" alignItems="center">
        <BusinessCenterIcon color="light" sx={{ mr: 1 }} />
        <MDBox sx={(theme) => sidenavLogoLabel(theme, { miniSidenav })}>
          <MDTypography component="h6" variant="button" fontWeight="medium" color={textColor}>
            Tech Intervention
          </MDTypography>
        </MDBox>
      </MDBox>
    );
  }

  const { url, company, image } = companyData;

  return !!image ? (
    <LogoHeader company={company} url={url} image={image} />
  ) : (
    <MDBox component={NavLink} to="/" display="flex" alignItems="center" sx={{ mb: 1, ml: 1 }}>
      <BusinessCenterIcon color="light">Business Center</BusinessCenterIcon>
      <MDBox width={!company && '100%'} sx={(theme) => sidenavLogoLabel(theme, { miniSidenav })}>
        <MDTypography component="h6" variant="button" fontWeight="medium" color={textColor}>
          {company}
        </MDTypography>
      </MDBox>
    </MDBox>
  );
};
CompanyHeader.displayName = 'CompanyHeader';
CompanyHeader.defaultProps = {
  companyData: null,
  miniSidenav: false,
};
CompanyHeader.propTypes = {
  companyData: PropTypes.shape({
    url: PropTypes.string,
    company: PropTypes.string,
    image: PropTypes.string,
  }),
  miniSidenav: PropTypes.bool,
  textColor: PropTypes.string.isRequired,
};
export default memo(CompanyHeader);
